<template>
    <div class="team-sheet-page-nav">
        <v-icon
            :color="page === 0 ? 'rgba(255,255,255,0.3)' : 'white'"
            :style="{pointerEvents: page === 0 ? 'none' : 'auto', cursor: page === 0 ? 'default' : 'pointer'}"
            @click="page > 0 && $emit('prev')"
        >mdi-chevron-left</v-icon>
        <span class="team-sheet-page-nav-label">{{ page + 1 }} / {{ total }}</span>
        <v-icon
            :color="page >= total - 1 ? 'rgba(255,255,255,0.3)' : 'white'"
            :style="{pointerEvents: page >= total - 1 ? 'none' : 'auto', cursor: page >= total - 1 ? 'default' : 'pointer'}"
            @click="page < total - 1 && $emit('next')"
        >mdi-chevron-right</v-icon>
    </div>
</template>

<script>
    // Čistý prezentační řádek se šipkami "‹ X / Y ›" - žádná byznys logika,
    // rodič (TeamBottomSheet.vue) drží stránku i počet stránek jako vlastní
    // stav a jen naslouchá @prev/@next. Třída .team-sheet-page-nav na
    // kořeni je globálně stabilní název, rodič ji používá jako
    // reserveSelectors cíl v measureFittingRowCount.
    export default {
        name: 'TeamSheetPagerNav',
        props: {
            page: {type: Number, required: true},
            total: {type: Number, required: true},
        },
    };
</script>

<style scoped>
.team-sheet-page-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 6px 0 0 0;
    height: 29px;
    box-sizing: border-box;
    flex-shrink: 0;
    /* Rodič je flex sloupec vysoký aspoň na celou .team-sheet-body -
       margin-top:auto proto dotlačí šipky vždy úplně dolů, místo aby
       zůstaly hned za posledním řádkem na kratší poslední stránce. */
    margin-top: auto;
}
.team-sheet-page-nav-label {
    color: rgba(255,255,255,0.8);
    font-size: 12px;
    min-width: 36px;
    text-align: center;
}
</style>
